module.exports = __webpack_public_path__ + "img/services.e6fa86d5.svg";